import Builder from './class-builder';

class ForgedIronBuilder extends Builder {

  /*
  * Render path for desktop
  */
  getRenderPathDesktop() {
    return this.renderDomain + 'forged-iron-spiral/desktop/';
  }

  /*
  * Render path for mobile
  */
  getRenderPathMobile() {
    return this.renderDomain + 'forged-iron-spiral/mobile/';
  }

  /*
  * Create image SKU
  */
  getRenderImage() {
    return 'SF3609' + this.getTreadProfileImage(this.selection_data.tread_profile) + this.getTreadCoveringImage(this.selection_data.tread_covering) + this.getWoodCoveringTypeImage(this.selection_data.wood_covering_type) + this.getBalusterPatternImage(this.selection_data.baluster_pattern) + this.getHandrailImage(this.selection_data.handrail) + this.getFinishImage(this.selection_data.finish);
  }

  /*
  * Match tread profile SKU
  */
  getTreadProfileImage(tread_profile) {
    switch (tread_profile) {
      case 'S':
      case 'L':
      case 'R':
        return tread_profile;
      case 'I':
        return 'S';
      default:
        return 'S';
    }
  }

  /*
  * Match tread covering SKU
  */
  getTreadCoveringImage(tread_covering) {
    switch (tread_covering) {
      case 'S':
      case 'W':
        return tread_covering;
      default:
        return 'S';
    }
  }

  /*
  * Match wood covering type SKU
  */
  getWoodCoveringTypeImage(wood_covering_type) {
    switch (wood_covering_type) {
      case 'N':
      case 'A':
        return wood_covering_type;
      case 'K':
      case 'L':
      case 'D':
      case 'E':
        return 'A';
      default:
        return 'N';
    }
  }

  /*
  * Match baluster pattern SKU
  */
  getBalusterPatternImage(baluster_pattern) {
    switch (baluster_pattern) {
      case 'D':
      case 'E':
        return baluster_pattern;
      case 'A':
      case 'B':
      case 'C':
      case 'F':
        return 'D';
      default:
        return 'D';
    }
  }

  /*
  * Match handrail SKU
  */
  getHandrailImage(handrail) {
    switch (handrail) {
      case 'A':
      case 'G':
        return handrail;
      default:
        return 'A';
    }
  }

  /*
  * Match finish SKU
  */
  getFinishImage(finish) {
    switch (finish) {
      case 'B':
      case 'C':
      case 'N':
        return finish;
      case 'D':
        return 'B';
      default:
        return 'B';
    }
  }

  /*
  * Create sku from object
  * The order of the sku matches the spreadsheet from Mary
  */
  setSku() {
    this.sku = this.selection_data.product_line + this.selection_data.width + this.selection_data.height + this.selection_data.tread_profile + this.selection_data.tread_covering + this.selection_data.wood_covering_type + this.selection_data.baluster_pattern + this.selection_data.handrail + this.selection_data.finish;
  }

  /*
  * Create object from sku
  * The order of the sku matches the spreadsheet from Mary
  */
  getSkuObject(sku) {
    var product_line,
        width,
        height,
        tread_profile,
        tread_covering,
        wood_covering_type,
        baluster_pattern,
        handrail,
        finish,
        selection_data = {};

    if (sku) {
      product_line = sku.substring(0, 2);
      width = sku.substring(2, 4);
      height = sku.substring(4, 6);
      tread_profile = sku.substring(6, 7);
      tread_covering = sku.substring(7, 8);
      wood_covering_type = sku.substring(8, 9);
      baluster_pattern = sku.substring(9, 10);
      handrail = sku.substring(10, 11);
      finish = sku.substring(11, 12);

      selection_data = {
        'product_line' : product_line,
        'width' : width,
        'height' : height,
        'tread_profile' : tread_profile,
        'tread_covering' : tread_covering,
        'wood_covering_type' : wood_covering_type,
        'baluster_pattern' : baluster_pattern,
        'handrail' : handrail,
        'finish' : finish,
      }
    }

    this.selection_data = selection_data;
    return selection_data;
  }
}

export default ForgedIronBuilder;
